import { PayloadAction } from 'typesafe-actions';
import { ExchangeCalculateContextActionTypes, ExchangeCalculateState } from './types';

const ExchangeCalculateReducer = (
  state: ExchangeCalculateState,
  action: PayloadAction<ExchangeCalculateContextActionTypes, any>,
): ExchangeCalculateState => {
  switch (action.type) {
    case ExchangeCalculateContextActionTypes.SetExchangeCalculateRequest:
      return {
        ...state,
        exchangeCalculateRequest: {
          fromCurrencyId: action.payload.fromCurrencyId,
          toCurrencyId: action.payload.toCurrencyId,
          amount: action.payload.amount,
        },
        isFirstExchangeCalculation: action.payload.isFirstExchangeCalculation,
      };
    default: {
      return state;
    }
  }
};

export { ExchangeCalculateReducer };
